import styled from 'styled-components'
import theme from 'theme_'

export const SubsManageContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const SubsManageBody = styled.div`
  display: flex;
  padding-top: 16px;
  gap: 16px;
  flex-direction: column;
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
  }
`

export const SubsManageLeftPanelContainer = styled.div`
  display: flex;
  width: 100%;
  @media ${theme.devices.tabletLandscape} {
    width: 65%;
  }
`
